import React, { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import {
    Accordion,
    AccordionSummary,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    AccordionDetails,
    Checkbox,
} from '@mui/material'
import AuthContext from '@/product/context/auth/authContext'
import ProductContext from '@/product/context/product/productContext'
import ProductCustomState from '@/custom/context/product/productContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import {
    dateTimeFormatFunction,
    isValidHttpUrl,
    formatDateTime,
} from '../../../custom/common/components'

const FilterModal = (props) => {
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const [openAccordion, setOpenAccordion] = useState(null)
    const productContext = useContext(ProductContext)
    const productCustomState = useContext(ProductCustomState)
    const { alldata_all_dropdown, allLocations, allCategory } =
        useContext(CustomCommonContext)
    const { allCountries, allStates, allCities } =
        useContext(ProductCommonContext)
    const { projectAction, responseStatus: responseStatusProduct } =
        productContext

    const statusFilter = [
        {
            value: 'live',
            show: 'Draft Listings',
        },
        {
            value: 'ready',
            show: 'Ready Listings',
        },
        {
            value: 'fix',
            show: 'Fix Listings',
        },
        {
            value: 'pending',
            show: 'Pending Listings',
        },
        {
            value: 'delete',
            show: 'Deleted Listings',
        },
    ]

    // const [selectedFilters, setSelectedFilters] = useState({
    //     status: '',
    //     sort: '',
    //     source: {},
    //     location: {},
    //     processor: {},
    // })

    // const handleFilterChange = (category, value, isSingleSelect = false) => {
    //     props.handleFilterChange(category, value)
    //     setSelectedFilters((prev) => {
    //         if (isSingleSelect) {
    //             return {
    //                 ...prev,
    //                 [category]: value,
    //             }
    //         } else {
    //             return {
    //                 ...prev,
    //                 [category]: {
    //                     ...prev[category],
    //                     [value]: !prev[category][value],
    //                 },
    //             }
    //         }
    //     })
    //     if (isSingleSelect) {
    //         setOpenAccordion(null)
    //     }
    // }

    const toggleAccordion = (accordionName) => {
        setOpenAccordion((prev) =>
            prev === accordionName ? null : accordionName
        )
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                className="returnflowDialog proEditView filterModalEdit"
            >
                <div className="filterHeader">
                    <h2>All Filters</h2>

                    <Button
                        className="material-symbols-outlined modalClosePerment justify-content-end"
                        onClick={props.handleClose}
                    >
                        <span className="material-icons">close</span>
                    </Button>
                </div>
                <DialogContent className="pb-2 filterDialog">
                    <Accordion
                        expanded={openAccordion === 'status'}
                        onChange={() => toggleAccordion('status')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="location-content"
                            id="location-header"
                        >
                            <Typography>Status</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {statusFilter.map((item, index) => (
                                <div key={item.id}>
                                    <label>
                                        <Checkbox
                                            checked={
                                                !!props.selectedFilters.status[
                                                    item.value
                                                ]
                                            }
                                            onChange={() =>
                                                props.handleFilterChange(
                                                    'status',
                                                    item.value,
                                                    false,
                                                    !props.selectedFilters
                                                        .status[item.value]
                                                )
                                            }
                                        />
                                        {item.show}
                                    </label>
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                    {/* <Accordion
                        expanded={openAccordion === 'status'}
                        onChange={() => toggleAccordion('status')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="status-content"
                            id="status-header"
                        >
                            <Typography>
                                {props.selectedFilters.status || 'Status'}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {statusFilter.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        props.handleFilterChange(
                                            'status',
                                            item.show,
                                            true
                                        )
                                        // setOpenAccordion(null)
                                    }}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '5px 0',
                                        color:
                                            props.selectedFilters.status
                                                .show === item
                                                ? '#696880'
                                                : 'black',
                                        fontWeight:
                                            props.selectedFilters.status
                                                .show === item
                                                ? '550'
                                                : '400',
                                    }}
                                >
                                    {item.show}
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion> */}

                    <Accordion
                        expanded={openAccordion === 'sort'}
                        onChange={() => toggleAccordion('sort')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="sort-content"
                            id="sort-header"
                        >
                            <Typography>
                                {props.selectedFilters.sort || 'Sort'}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {[
                                'Retail Price High to Low',
                                'Retail Price Low to High',
                                'Recently Added A-Z',
                                'Recently Added Z-A',
                                'Buy Now High to Low',
                                'Buy Now Low to High',
                                'Ending Soonest',
                                'Ending Furthest',
                                'Recently Updated A-Z',
                                'Recently Updated Z-A',
                            ].map((item) => (
                                <div
                                    key={item}
                                    onClick={() => {
                                        props.handleFilterChange(
                                            'sort',
                                            item,
                                            true
                                        )
                                        setOpenAccordion(null)
                                    }}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '5px 0',
                                        color:
                                            props.selectedFilters.sort === item
                                                ? '#696880'
                                                : 'black',
                                        fontWeight:
                                            props.selectedFilters.sort === item
                                                ? '550'
                                                : '400',
                                    }}
                                >
                                    {item}
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>

                    {/* Source Accordion */}
                    {/* <Accordion
                        expanded={openAccordion === 'source'}
                        onChange={() => toggleAccordion('source')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="source-content"
                            id="source-header"
                        >
                            <Typography>Source</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {[
                                'PA23574836 (24)',
                                'PA12232387 (243)',
                                'PA09029733',
                                'PA124872356',
                                'PA39756786',
                                'PA38564765',
                            ].map((item) => (
                                <div key={item}>
                                    <label>
                                        <Checkbox
                                            checked={
                                                !!props.selectedFilters.source[
                                                    item
                                                ]
                                            }
                                            onChange={() =>
                                                props.handleFilterChange(
                                                    'source',
                                                    item
                                                )
                                            }
                                        />
                                        {item}
                                    </label>
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion> */}

                    {/* Location Accordion */}
                    <Accordion
                        expanded={openAccordion === 'location'}
                        onChange={() => toggleAccordion('location')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="location-content"
                            id="location-header"
                        >
                            <Typography>Location</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {allLocations
                                .filter(
                                    (location) =>
                                        location.active &&
                                        (user?.emp_type === 'seller'
                                            ? user?.emp_location
                                                  .split(',')
                                                  .includes(
                                                      location.id.toString()
                                                  )
                                            : true)
                                )
                                .map((item) => (
                                    <div key={item.id}>
                                        <label>
                                            <Checkbox
                                                checked={
                                                    !!props.selectedFilters
                                                        .location[item.id]
                                                }
                                                onChange={() =>
                                                    props.handleFilterChange(
                                                        'location',
                                                        item.id,
                                                        false,
                                                        !props.selectedFilters
                                                            .location[item.id]
                                                    )
                                                }
                                            />
                                            {item.name}
                                        </label>
                                    </div>
                                ))}
                        </AccordionDetails>
                    </Accordion>

                    {/* Processor acoo */}
                    <Accordion
                        expanded={openAccordion === 'processor'}
                        onChange={() => toggleAccordion('processor')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <span className="material-icons">
                                    expand_more
                                </span>
                            }
                            aria-controls="location-content"
                            id="location-header"
                        >
                            <Typography>Processor</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {props.allEmployees
                                .filter((emp) => emp.emp_status === 'active')
                                .map((item) => (
                                    <div key={item.id}>
                                        <label>
                                            <Checkbox
                                                checked={
                                                    !!props.selectedFilters
                                                        .processor[item.id]
                                                }
                                                onChange={() =>
                                                    props.handleFilterChange(
                                                        'processor',
                                                        item.id,
                                                        false,
                                                        !props.selectedFilters
                                                            .processor[item.id]
                                                    )
                                                }
                                            />
                                            {item.emp_firstname}{' '}
                                            {item.emp_lastname}
                                        </label>
                                    </div>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                </DialogContent>
                <DialogActions className="justify-content-center mt-1 filterDialogActions">
                    <Button
                        type="submit"
                        className="PrimaryButton"
                        variant="contained"
                        onClick={props.clearAllSelections}
                        style={{ marginTop: '20px' }}
                    >
                        Clear All
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FilterModal
